var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0357 1.71308C12.4281 1.32072 12.4281 0.685293 12.0357 0.294263C11.6447 -0.0980878 11.0093 -0.0980878 10.6169 0.294263L6.165 4.74488L1.71441 0.294263C1.32205 -0.0980878 0.686615 -0.0980878 0.294263 0.294263C-0.0980878 0.685293 -0.0980878 1.32072 0.294263 1.71308L4.74619 6.165L0.294263 10.6156C-0.0980878 11.0079 -0.0980878 11.6434 0.294263 12.0357C0.686615 12.4268 1.32205 12.4268 1.71308 12.0357L6.165 7.58381L10.6169 12.0357C11.0093 12.4281 11.6447 12.4281 12.0357 12.0357C12.4281 11.6434 12.4281 11.0079 12.0357 10.6156L7.58514 6.165L12.0357 1.71308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c4cce031aeee2d265ae825aef9dd4fc.svg";
export { ForwardRef as ReactComponent };